import _ from "lodash";
import * as ROUTES from "../constants/routes";

// Function help to get the menu items config
const getSystemMenuItems = (feature) => {
  const tenkenMenuItems = {
    inspection: {
      icon: "menu-inspection",
      title: "点検",
      description: "点検結果を登録します",
      link: ROUTES.MACHINE_INPUT,
    },
    judgment: {
      icon: "menu-judgment",
      title: "承認",
      description: "点検結果を承認します",
      link: ROUTES.JUDGMENT,
    },
    treatment: {
      icon: "menu-treatment",
      title: "処置",
      description: "問題があった点検結果を再点検します",
      link: ROUTES.UNFINISHED_ACTION_LIST,
    },
    "inspection-status": {
      icon: "menu-inspection-status",
      title: "点検状況",
      description: "点検状況を一覧表示します",
      link: ROUTES.INSPECTION_STATUS,
    },
    "inspection-sheet": {
      icon: "menu-inspection-sheet",
      title: "点検表",
      description: "点検結果を一覧表示します",
      link: ROUTES.INSPECTION_SHEET,
    },
    search: {
      icon: "menu-search",
      title: "詳細検索",
      description: "点検結果を検索・修正します",
      link: ROUTES.SEARCH,
    },
    master: {
      icon: "menu-master",
      title: "マスタ更新",
      description: "マスタを更新します",
      link: ROUTES.MASTER_DASHBOARD,
    }
  };

  const userMenuItems = {
    "user-master-update": {
      icon: "menu-user-master-update",
      title: "ユーザーマスタ更新",
      description: "手動でユーザーマスタを更新します",
      link: ROUTES.USER_MASTER_UPDATE,
    },
    "user-master-history-search": {
      icon: "menu-user-master-history-search",
      title: "ユーザーマスタ更新履歴検索",
      description: "ユーザーマスタの更新履歴を検索します",
      link: ROUTES.USER_MASTER_HISTORY_SEARCH,
    },
    "user-master-import": {
      icon: "menu-user-master-import",
      title: "ユーザーマスタインポート",
      description: "Excelファイルを使用してユーザーマスタを更新します",
      link: ROUTES.USER_MASTER_IMPORT,
    },
    "user-master-export": {
      icon: "menu-user-master-export",
      title: "ユーザーマスタエクスポート",
      description: "現在のユーザーマスタの状態をExcelファイルに出力します",
      link: ROUTES.USER_MASTER_EXPORT,
    },
    "user-master-search": {
      icon: "menu-user-master-search",
      title: "ユーザーマスタ検索",
      description: "ユーザーマスタを検索します",
      link: ROUTES.USER_MASTER_SEARCH,
    },
  };

  const masterMenuItems = {
    "machine-master-top": {
      icon: "menu-machine-master",
      title: "設備マスタ",
      description: "設備マスタの操作を行います",
      link: ROUTES.MACHINE_MASTER_DASHBOARD,
    },
    "department-master-top": {
      icon: "menu-department-master",
      title: "部門マスタ",
      description: "部門マスタの操作を行います",
      link: ROUTES.DEPARTMENT_MASTER_DASHBOARD,
    },
    "position-master-top": {
      icon: "menu-position-master",
      title: "職位マスタ",
      description: "職位マスタの操作を行います",
      link: ROUTES.POSITION_MASTER_DASHBOARD,
    },
    "approval-setting-master-top": {
      icon: "menu-approval-setting",
      title: "承認設定マスタ",
      description: "承認フローを作成・編集します",
      link: ROUTES.APPROVAL_SETTING_MASTER_DASHBOARD,
    },
    "inspection-template-master-top": {
      icon: "menu-template-management",
      title: "点検テンプレートマスタ",
      description: "点検テンプレートを作成・編集します",
      link: ROUTES.INSPECTION_TEMPLATE_MASTER_DASHBOARD,
    },
  };

  const machinesMenuItems = {
    "machine-master-update": {
      icon: "menu-machine-master-update",
      title: "設備マスタ更新",
      description: "手動で設備マスタを更新します",
      link: ROUTES.MACHINE_MASTER_UPDATE,
    },
    "machine-master-history-search": {
      icon: "menu-machine-master-history-search",
      title: "設備マスタ更新履歴検索",
      description: "設備マスタの更新履歴を検索します",
      link: ROUTES.MACHINE_MASTER_HISTORY_SEARCH,
    },
    "machine-master-import": {
      icon: "menu-machine-master-import",
      title: "設備マスタインポート",
      description: "Excelファイルを使用して設備マスタを更新します",
      link: ROUTES.MACHINE_MASTER_IMPORT,
    },
    "machine-master-export": {
      icon: "menu-machine-master-export",
      title: "設備マスタエクスポート",
      description: "現在の設備マスタの状態をExcelファイルに出力します",
      link: ROUTES.MACHINE_MASTER_EXPORT,
    },
    "machine-master-group-update": {
      icon: "menu-machine-master-group-update",
      title: "設備グループマスタ更新",
      description: "各設備がどの場所のどの工程に割り当てられるかを定義します",
      link: ROUTES.MACHINE_MASTER_GROUP_UPDATE,
    },
  };

  const departmentMenuItems = {
    "department-master-update": {
      icon: "menu-department-master-update",
      title: "部門マスタ更新",
      description: "手動で部門マスタを更新します",
      link: ROUTES.DEPARTMENT_MASTER_UPDATE,
    },
    "department-master-history-search": {
      icon: "menu-department-master-history-search",
      title: "部門マスタ更新履歴検索",
      description: "部門マスタの更新履歴を検索します",
      link: ROUTES.DEPARTMENT_MASTER_HISTORY_SEARCH,
    },
    "department-master-import": {
      icon: "menu-department-master-import",
      title: "部門マスタインポート",
      description: "Excelファイルを使用して部門マスタを更新します",
      link: ROUTES.DEPARTMENT_MASTER_IMPORT,
    },
    "department-master-export": {
      icon: "menu-department-master-export",
      title: "部門マスタエクスポート",
      description: "現在の部門マスタの状態をExcelファイルに出力します",
      link: ROUTES.DEPARTMENT_MASTER_EXPORT,
    },
  };

  const positionsMenuItems = {
    "position-master-update": {
      icon: "menu-position-master-update",
      title: "職位マスタ更新",
      description: "手動で職位マスタを更新します",
      link: ROUTES.POSITION_MASTER_UPDATE,
    },
    "position-master-history-search": {
      icon: "menu-position-master-history-search",
      title: "職位マスタ更新履歴検索",
      description: "職位マスタの更新履歴を検索します",
      link: ROUTES.POSITION_MASTER_HISTORY_SEARCH,
    },
    "position-master-import": {
      icon: "menu-position-master-import",
      title: "職位マスタインポート",
      description: "Excelファイルを使用して職位マスタを更新します",
      link: ROUTES.POSITION_MASTER_IMPORT,
    },
    "position-master-export": {
      icon: "menu-position-master-export",
      title: "職位マスタエクスポート",
      description: "現在の職位マスタの状態をExcelファイルに出力します",
      link: ROUTES.POSITION_MASTER_EXPORT,
    },
  };

  const approvalSettingsMenuItems = {
    "approval-setting-master-update": {
      icon: "menu-position-master-update",
      title: "承認設定マスタ更新",
      description: "手動で承認設定マスタを更新します",
      link: ROUTES.APPROVAL_SETTING,
    },
    "approval-setting-master-history-search": {
      icon: "menu-position-master-history-search",
      title: "承認設定マスタ更新履歴検索",
      description: "承認設定マスタの更新履歴を検索します",
      link: ROUTES.APPROVAL_SETTING_MASTER_SEARCH,
    },
    "approval-setting-master-import": {
      icon: "menu-position-master-import",
      title: "承認設定マスタインポート",
      description: "Excelファイルを使用して承認設定マスタを更新します",
      link: ROUTES.APPROVAL_SETTING_MASTER_IMPORT,
    },
    "approval-setting-master-export": {
      icon: "menu-position-master-export",
      title: "承認設定マスタエクスポート",
      description: "現在の承認設定マスタの状態をExcelファイルに出力します",
      link: ROUTES.APPROVAL_SETTING_MASTER_EXPORT,
    },
  };

  const inspectionTemplatesMenuItems = {
    "inspection-template-master-update": {
      icon: "menu-position-master-update",
      title: "点検テンプレートマスタ更新",
      description: "手動で点検テンプレートマスタを更新します",
      link: ROUTES.TEMPLATE_MANAGEMENT,
    },
    "inspection-template-master-history-search": {
      icon: "menu-position-master-history-search",
      title: "点検テンプレートマスタ更新履歴検索",
      description: "点検テンプレートマスタの更新履歴を検索します",
      link: ROUTES.INSPECTION_TEMPLATE_MASTER_SEARCH,
    },
    "inspection-template-master-import": {
      icon: "menu-position-master-import",
      title: "点検テンプレートマスタインポート",
      description: "Excelファイルを使用して点検テンプレートマスタを更新します",
      link: ROUTES.INSPECTION_TEMPLATE_MASTER_IMPORT,
    },
    "inspection-template-master-export": {
      icon: "menu-position-master-export",
      title: "点検テンプレートマスタエクスポート",
      description: "現在の点検テンプレートマスタの状態をExcelファイルに出力します",
      link: ROUTES.INSPECTION_TEMPLATE_MASTER_EXPORT,
    },
  };

  switch (feature) {
    case "tenken":
      return tenkenMenuItems;
    case "user":
      return userMenuItems;
    case "master":
      return masterMenuItems;
    case "machine":
      return machinesMenuItems;
    case "department":
      return departmentMenuItems;
    case "position":
      return positionsMenuItems;
    case "approval-settings":
      return approvalSettingsMenuItems;
    case "inspection-templates":
      return inspectionTemplatesMenuItems;
    default:
      return tenkenMenuItems;
  }
};

// Function help to get menu item
const getMenuItem = (name, feature = "tenken") => {
  const menuItems = getSystemMenuItems(feature);
  if (_.isEmpty(menuItems[name])) {
    return undefined;
  }
  return menuItems[name];
};

export { getMenuItem };
